export default "__VITE_ASSET__6292da29__"